import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatedSection } from './AnimatedSection';
interface CTASectionProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
  light?: boolean;
}
export function CTASection({
  title = 'Direct inzicht in de waarde van uw onderneming',
  subtitle = 'Krijg een objectieve, professionele waardering die u helpt bij strategische beslissingen.',
  buttonText = 'Start waardebepaling',
  buttonLink = '/bedrijfswaardering',
  light = false
}: CTASectionProps) {
  const bgClass = light ? 'bg-offwhite' : 'bg-charcoal';
  const titleClass = light ? 'text-charcoal' : 'text-white';
  const subtitleClass = light ? 'text-charcoal/70' : 'text-warmgray/80';
  return <section className={`py-24 ${bgClass}`} data-id="element-87">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12" data-id="element-88">
        <AnimatedSection className="max-w-3xl mx-auto text-center" data-id="element-89">
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-light tracking-tight mb-6 ${titleClass}`} data-id="element-90">
            {title}
          </h2>
          <p className={`text-lg mb-10 ${subtitleClass}`} data-id="element-91">{subtitle}</p>
          <Link to={buttonLink} className="inline-block bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-full text-base font-medium transition-all shadow-subtle hover:shadow-premium" data-id="element-92">
            {buttonText}
          </Link>
        </AnimatedSection>
      </div>
    </section>;
}